<template>
    <div class="card-body">
        <ul class="legend">
            <li>
                <span class="color" :style="[{'backgroundColor': borderColorFromStatus('draft') }]"></span>
                <span class="text">Szkic</span>
            </li>
            <li>
                <span class="color" :style="[{'backgroundColor': borderColorFromStatus('not_accepted') }]"></span>
                <span class="text">Niezaakceptowana</span>
            </li>
            <li>
                <span class="color" :style="[{'backgroundColor': borderColorFromStatus('during') }]"></span>
                <span class="text">W trakcie</span>
            </li>
            <li>
                <span class="color" :style="[{'backgroundColor': borderColorFromStatus('not_paid_on_time') }]"></span>
                <span class="text">Niespłacona w terminie</span>
            </li>
            <li>
                <span class="color" :style="[{'backgroundColor': borderColorFromStatus('closed') }]"></span>
                <span class="text">Zamknięta</span>
            </li>
            <li>
                <span class="color" :style="[{'backgroundColor': borderColorFromStatus('archived') }]"></span>
                <span class="text">Zarchiwizowana</span>
            </li>
            <li>
                <span class="color" :style="[{'backgroundColor': borderColorFromStatus('in_execution') }]"></span>
                <span class="text">W egzekucji</span>
            </li>
            <li>
                <span class="color" :style="[{'backgroundColor': borderColorFromStatus('terminated') }]"></span>
                <span class="text">Wypowiedziana</span>
            </li>
        </ul>
    </div>
</template>



<script>
    import ColorUtils from '../../utils/colors';

    export default {
        methods: {
            borderColorFromStatus(status){
                return status ? ColorUtils.status[status] : 'transparent';
            },
        }
    }
</script>


<!-- my-component.vue -->
<style lang="scss" scoped>
    .legend{
        padding: 0;
        margin: 10px 0;
        list-style: none;
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        li{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            min-width: 180px;
            padding-right: 15px;
            color: gray;
            font-size: 12px;

            .color{
                width: 20px;
                height: 5px;
                margin-top: -2px;
                margin-right: 15px;
            }
        }
    }
</style>
